// extracted by mini-css-extract-plugin
export default {"iconWrapper":"PasswordInput_iconWrapper__XElUO"};